export const ACCESS_TOKEN = 'Access-Token'
export const SIDEBAR_TYPE = 'SIDEBAR_TYPE'
export const DEFAULT_THEME = 'DEFAULT_THEME'
export const DEFAULT_LAYOUT_MODE = 'DEFAULT_LAYOUT_MODE'
export const DEFAULT_COLOR = 'DEFAULT_COLOR'
export const DEFAULT_COLOR_WEAK = 'DEFAULT_COLOR_WEAK'
export const DEFAULT_FIXED_HEADER = 'DEFAULT_FIXED_HEADER'
export const DEFAULT_FIXED_SIDEMENU = 'DEFAULT_FIXED_SIDEMENU'
export const DEFAULT_FIXED_HEADER_HIDDEN = 'DEFAULT_FIXED_HEADER_HIDDEN'
export const DEFAULT_CONTENT_WIDTH_TYPE = 'DEFAULT_CONTENT_WIDTH_TYPE'
export const DEFAULT_MULTI_TAB = 'DEFAULT_MULTI_TAB'
export const STATUS_ACTIVE = 'active'
export const STATUS_DELETED = 'deleted'
export const TYPE_PURCHASE_BILL_IN = 'purchase_bill_in'
export const TYPE_PURCHASE_BILL_OUT = 'purchase_bill_out'
export const TYPE_PURCHASE_INVOICE_IN = 'purchase_invoice_in'
export const TYPE_PURCHASE_RECEDE = 'purchase_recede'
export const TYPE_NOT = 'not'
export const TYPE_PART = 'part'
export const TYPE_ALL = 'all'

export const TYPE_SALES_BILL_OUT = 'sales_bill_out'
export const TYPE_SALES_BILL_IN = 'sales_bill_in'
export const TYPE_SALES_INVOICE_OUT = 'sales_invoice_out'
export const TYPE_SALES_RECEDE = 'sales_recede'

export const TYPE_OTHER_IN = 'other_in'
export const TYPE_PANYING = 'panying'
export const TYPE_OTHER_OUT = 'other_out'
export const TYPE_PANKUI = 'pankui'
export const TYPE_ORIGINAL = 'original'

export const CODE_FAIL = 'fail'

export const CONTENT_WIDTH_TYPE = {
  Fluid: 'Fluid',
  Fixed: 'Fixed'
}
